import { Button, Modal } from '../../../components';
import { Disclaimer, H3, P } from '../../../styles/text';
import { Div } from '../../../styles/styles';
import { lightTheme } from '../../../styles/theme';

export const PushOrdersToPosModal = ({
  isOpen,
  closeModal,
  onConfirm,
  storeName,
}: {
  isOpen: boolean;
  closeModal: () => void;
  onConfirm: (enablePushOrdersToPos: boolean) => void;
  storeName?: string;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      closeModal={closeModal}
      logo={false}
      exitButton={false}
    >
      <H3 $mb="8">Enable Push Orders to POS?</H3>
      <P $mb="24">
        Push orders to POS is currently disabled for this brand. Do you want to
        enable it as part of this publish?
      </P>
      {/* {storeName && (
        <Disclaimer $mb="24" $color={lightTheme.lightGray}>
          {storeName}
        </Disclaimer>
      )} */}

      <Div $flex $gap="16px">
        <Button $w="100%" $selected onClick={() => onConfirm(true)}>
          Yes, enable
        </Button>
        <Button $w="100%" $selected $gray onClick={() => onConfirm(false)}>
          No, just publish
        </Button>
      </Div>
    </Modal>
  );
};
